module.exports = __webpack_public_path__ + "static/media/facebook-lead-ads.e4e50ede.svg";